var _rect, _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgHeaderSidepages(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 1747,
    height: 776,
    viewBox: "0 0 1747 776",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_27_234",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 1747,
    height: 776
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 1747,
    height: 776,
    fill: "url(#paint0_linear_27_234)"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_27_234)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 387,
    cy: 365,
    r: 320,
    fill: "url(#paint1_radial_27_234)"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 907,
    cy: 640,
    r: 320,
    fill: "url(#paint2_radial_27_234)"
  }), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_27_234)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M42 -42L89.6314 -14.5V40.5L42 68L-5.6314 40.5V-14.5L42 -42Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-8 42L39.6314 69.5V124.5L-8 152L-55.6314 124.5V69.5L-8 42Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M142 -42L189.631 -14.5V40.5L142 68L94.3686 40.5V-14.5L142 -42Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M92 42L139.631 69.5V124.5L92 152L44.3686 124.5V69.5L92 42Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M242 -42L289.631 -14.5V40.5L242 68L194.369 40.5V-14.5L242 -42Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M192 42L239.631 69.5V124.5L192 152L144.369 124.5V69.5L192 42Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M342 -42L389.631 -14.5V40.5L342 68L294.369 40.5V-14.5L342 -42Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M292 42L339.631 69.5V124.5L292 152L244.369 124.5V69.5L292 42Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M442 -42L489.631 -14.5V40.5L442 68L394.369 40.5V-14.5L442 -42Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M392 42L439.631 69.5V124.5L392 152L344.369 124.5V69.5L392 42Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M542 -42L589.631 -14.5V40.5L542 68L494.369 40.5V-14.5L542 -42Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M492 42L539.631 69.5V124.5L492 152L444.369 124.5V69.5L492 42Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M42 126L89.6314 153.5V208.5L42 236L-5.6314 208.5V153.5L42 126Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-8 210L39.6314 237.5V292.5L-8 320L-55.6314 292.5V237.5L-8 210Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M142 126L189.631 153.5V208.5L142 236L94.3686 208.5V153.5L142 126Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M92 210L139.631 237.5V292.5L92 320L44.3686 292.5V237.5L92 210Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M242 126L289.631 153.5V208.5L242 236L194.369 208.5V153.5L242 126Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M192 210L239.631 237.5V292.5L192 320L144.369 292.5V237.5L192 210Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M342 126L389.631 153.5V208.5L342 236L294.369 208.5V153.5L342 126Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M292 210L339.631 237.5V292.5L292 320L244.369 292.5V237.5L292 210Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M442 126L489.631 153.5V208.5L442 236L394.369 208.5V153.5L442 126Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M392 210L439.631 237.5V292.5L392 320L344.369 292.5V237.5L392 210Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M542 126L589.631 153.5V208.5L542 236L494.369 208.5V153.5L542 126Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M492 210L539.631 237.5V292.5L492 320L444.369 292.5V237.5L492 210Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M42 294L89.6314 321.5V376.5L42 404L-5.6314 376.5V321.5L42 294Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-8 378L39.6314 405.5V460.5L-8 488L-55.6314 460.5V405.5L-8 378Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M142 294L189.631 321.5V376.5L142 404L94.3686 376.5V321.5L142 294Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M92 378L139.631 405.5V460.5L92 488L44.3686 460.5V405.5L92 378Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M242 294L289.631 321.5V376.5L242 404L194.369 376.5V321.5L242 294Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M192 378L239.631 405.5V460.5L192 488L144.369 460.5V405.5L192 378Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M342 294L389.631 321.5V376.5L342 404L294.369 376.5V321.5L342 294Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M292 378L339.631 405.5V460.5L292 488L244.369 460.5V405.5L292 378Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M442 294L489.631 321.5V376.5L442 404L394.369 376.5V321.5L442 294Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M392 378L439.631 405.5V460.5L392 488L344.369 460.5V405.5L392 378Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M542 294L589.631 321.5V376.5L542 404L494.369 376.5V321.5L542 294Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M492 378L539.631 405.5V460.5L492 488L444.369 460.5V405.5L492 378Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M42 462L89.6314 489.5V544.5L42 572L-5.6314 544.5V489.5L42 462Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-8 546L39.6314 573.5V628.5L-8 656L-55.6314 628.5V573.5L-8 546Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M142 462L189.631 489.5V544.5L142 572L94.3686 544.5V489.5L142 462Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M92 546L139.631 573.5V628.5L92 656L44.3686 628.5V573.5L92 546Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M242 462L289.631 489.5V544.5L242 572L194.369 544.5V489.5L242 462Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M192 546L239.631 573.5V628.5L192 656L144.369 628.5V573.5L192 546Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M342 462L389.631 489.5V544.5L342 572L294.369 544.5V489.5L342 462Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M292 546L339.631 573.5V628.5L292 656L244.369 628.5V573.5L292 546Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M442 462L489.631 489.5V544.5L442 572L394.369 544.5V489.5L442 462Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M392 546L439.631 573.5V628.5L392 656L344.369 628.5V573.5L392 546Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M542 462L589.631 489.5V544.5L542 572L494.369 544.5V489.5L542 462Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M492 546L539.631 573.5V628.5L492 656L444.369 628.5V573.5L492 546Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M42 630L89.6314 657.5V712.5L42 740L-5.6314 712.5V657.5L42 630Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-8 714L39.6314 741.5V796.5L-8 824L-55.6314 796.5V741.5L-8 714Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M142 630L189.631 657.5V712.5L142 740L94.3686 712.5V657.5L142 630Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M92 714L139.631 741.5V796.5L92 824L44.3686 796.5V741.5L92 714Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M242 630L289.631 657.5V712.5L242 740L194.369 712.5V657.5L242 630Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M192 714L239.631 741.5V796.5L192 824L144.369 796.5V741.5L192 714Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M342 630L389.631 657.5V712.5L342 740L294.369 712.5V657.5L342 630Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M292 714L339.631 741.5V796.5L292 824L244.369 796.5V741.5L292 714Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M442 630L489.631 657.5V712.5L442 740L394.369 712.5V657.5L442 630Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M392 714L439.631 741.5V796.5L392 824L344.369 796.5V741.5L392 714Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M542 630L589.631 657.5V712.5L542 740L494.369 712.5V657.5L542 630Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M492 714L539.631 741.5V796.5L492 824L444.369 796.5V741.5L492 714Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M642 -42L689.631 -14.5V40.5L642 68L594.369 40.5V-14.5L642 -42Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M592 42L639.631 69.5V124.5L592 152L544.369 124.5V69.5L592 42Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M742 -42L789.631 -14.5V40.5L742 68L694.369 40.5V-14.5L742 -42Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M692 42L739.631 69.5V124.5L692 152L644.369 124.5V69.5L692 42Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M842 -42L889.631 -14.5V40.5L842 68L794.369 40.5V-14.5L842 -42Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M792 42L839.631 69.5V124.5L792 152L744.369 124.5V69.5L792 42Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M942 -42L989.631 -14.5V40.5L942 68L894.369 40.5V-14.5L942 -42Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M892 42L939.631 69.5V124.5L892 152L844.369 124.5V69.5L892 42Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1042 -42L1089.63 -14.5V40.5L1042 68L994.369 40.5V-14.5L1042 -42Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M992 42L1039.63 69.5V124.5L992 152L944.369 124.5V69.5L992 42Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1142 -42L1189.63 -14.5V40.5L1142 68L1094.37 40.5V-14.5L1142 -42Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1092 42L1139.63 69.5V124.5L1092 152L1044.37 124.5V69.5L1092 42Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M642 126L689.631 153.5V208.5L642 236L594.369 208.5V153.5L642 126Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M592 210L639.631 237.5V292.5L592 320L544.369 292.5V237.5L592 210Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M742 126L789.631 153.5V208.5L742 236L694.369 208.5V153.5L742 126Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M692 210L739.631 237.5V292.5L692 320L644.369 292.5V237.5L692 210Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M842 126L889.631 153.5V208.5L842 236L794.369 208.5V153.5L842 126Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M792 210L839.631 237.5V292.5L792 320L744.369 292.5V237.5L792 210Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M942 126L989.631 153.5V208.5L942 236L894.369 208.5V153.5L942 126Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M892 210L939.631 237.5V292.5L892 320L844.369 292.5V237.5L892 210Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1042 126L1089.63 153.5V208.5L1042 236L994.369 208.5V153.5L1042 126Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M992 210L1039.63 237.5V292.5L992 320L944.369 292.5V237.5L992 210Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1142 126L1189.63 153.5V208.5L1142 236L1094.37 208.5V153.5L1142 126Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1092 210L1139.63 237.5V292.5L1092 320L1044.37 292.5V237.5L1092 210Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M642 294L689.631 321.5V376.5L642 404L594.369 376.5V321.5L642 294Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M592 378L639.631 405.5V460.5L592 488L544.369 460.5V405.5L592 378Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M742 294L789.631 321.5V376.5L742 404L694.369 376.5V321.5L742 294Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M692 378L739.631 405.5V460.5L692 488L644.369 460.5V405.5L692 378Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M842 294L889.631 321.5V376.5L842 404L794.369 376.5V321.5L842 294Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M792 378L839.631 405.5V460.5L792 488L744.369 460.5V405.5L792 378Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M942 294L989.631 321.5V376.5L942 404L894.369 376.5V321.5L942 294Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M892 378L939.631 405.5V460.5L892 488L844.369 460.5V405.5L892 378Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1042 294L1089.63 321.5V376.5L1042 404L994.369 376.5V321.5L1042 294Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M992 378L1039.63 405.5V460.5L992 488L944.369 460.5V405.5L992 378Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1142 294L1189.63 321.5V376.5L1142 404L1094.37 376.5V321.5L1142 294Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1092 378L1139.63 405.5V460.5L1092 488L1044.37 460.5V405.5L1092 378Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M642 462L689.631 489.5V544.5L642 572L594.369 544.5V489.5L642 462Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M592 546L639.631 573.5V628.5L592 656L544.369 628.5V573.5L592 546Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M742 462L789.631 489.5V544.5L742 572L694.369 544.5V489.5L742 462Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M692 546L739.631 573.5V628.5L692 656L644.369 628.5V573.5L692 546Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M842 462L889.631 489.5V544.5L842 572L794.369 544.5V489.5L842 462Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M792 546L839.631 573.5V628.5L792 656L744.369 628.5V573.5L792 546Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M942 462L989.631 489.5V544.5L942 572L894.369 544.5V489.5L942 462Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M892 546L939.631 573.5V628.5L892 656L844.369 628.5V573.5L892 546Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1042 462L1089.63 489.5V544.5L1042 572L994.369 544.5V489.5L1042 462Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M992 546L1039.63 573.5V628.5L992 656L944.369 628.5V573.5L992 546Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1142 462L1189.63 489.5V544.5L1142 572L1094.37 544.5V489.5L1142 462Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1092 546L1139.63 573.5V628.5L1092 656L1044.37 628.5V573.5L1092 546Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M642 630L689.631 657.5V712.5L642 740L594.369 712.5V657.5L642 630Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M592 714L639.631 741.5V796.5L592 824L544.369 796.5V741.5L592 714Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M742 630L789.631 657.5V712.5L742 740L694.369 712.5V657.5L742 630Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M692 714L739.631 741.5V796.5L692 824L644.369 796.5V741.5L692 714Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M842 630L889.631 657.5V712.5L842 740L794.369 712.5V657.5L842 630Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M792 714L839.631 741.5V796.5L792 824L744.369 796.5V741.5L792 714Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M942 630L989.631 657.5V712.5L942 740L894.369 712.5V657.5L942 630Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M892 714L939.631 741.5V796.5L892 824L844.369 796.5V741.5L892 714Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1042 630L1089.63 657.5V712.5L1042 740L994.369 712.5V657.5L1042 630Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M992 714L1039.63 741.5V796.5L992 824L944.369 796.5V741.5L992 714Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1142 630L1189.63 657.5V712.5L1142 740L1094.37 712.5V657.5L1142 630Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1092 714L1139.63 741.5V796.5L1092 824L1044.37 796.5V741.5L1092 714Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1242 -42L1289.63 -14.5V40.5L1242 68L1194.37 40.5V-14.5L1242 -42Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1192 42L1239.63 69.5V124.5L1192 152L1144.37 124.5V69.5L1192 42Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1342 -42L1389.63 -14.5V40.5L1342 68L1294.37 40.5V-14.5L1342 -42Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1292 42L1339.63 69.5V124.5L1292 152L1244.37 124.5V69.5L1292 42Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1442 -42L1489.63 -14.5V40.5L1442 68L1394.37 40.5V-14.5L1442 -42Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1392 42L1439.63 69.5V124.5L1392 152L1344.37 124.5V69.5L1392 42Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1542 -42L1589.63 -14.5V40.5L1542 68L1494.37 40.5V-14.5L1542 -42Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1492 42L1539.63 69.5V124.5L1492 152L1444.37 124.5V69.5L1492 42Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1642 -42L1689.63 -14.5V40.5L1642 68L1594.37 40.5V-14.5L1642 -42Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1592 42L1639.63 69.5V124.5L1592 152L1544.37 124.5V69.5L1592 42Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1742 -42L1789.63 -14.5V40.5L1742 68L1694.37 40.5V-14.5L1742 -42Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1692 42L1739.63 69.5V124.5L1692 152L1644.37 124.5V69.5L1692 42Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1242 126L1289.63 153.5V208.5L1242 236L1194.37 208.5V153.5L1242 126Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1192 210L1239.63 237.5V292.5L1192 320L1144.37 292.5V237.5L1192 210Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1342 126L1389.63 153.5V208.5L1342 236L1294.37 208.5V153.5L1342 126Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1292 210L1339.63 237.5V292.5L1292 320L1244.37 292.5V237.5L1292 210Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1442 126L1489.63 153.5V208.5L1442 236L1394.37 208.5V153.5L1442 126Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1392 210L1439.63 237.5V292.5L1392 320L1344.37 292.5V237.5L1392 210Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1542 126L1589.63 153.5V208.5L1542 236L1494.37 208.5V153.5L1542 126Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1492 210L1539.63 237.5V292.5L1492 320L1444.37 292.5V237.5L1492 210Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1642 126L1689.63 153.5V208.5L1642 236L1594.37 208.5V153.5L1642 126Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1592 210L1639.63 237.5V292.5L1592 320L1544.37 292.5V237.5L1592 210Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1742 126L1789.63 153.5V208.5L1742 236L1694.37 208.5V153.5L1742 126Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1692 210L1739.63 237.5V292.5L1692 320L1644.37 292.5V237.5L1692 210Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1242 294L1289.63 321.5V376.5L1242 404L1194.37 376.5V321.5L1242 294Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1192 378L1239.63 405.5V460.5L1192 488L1144.37 460.5V405.5L1192 378Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1342 294L1389.63 321.5V376.5L1342 404L1294.37 376.5V321.5L1342 294Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1292 378L1339.63 405.5V460.5L1292 488L1244.37 460.5V405.5L1292 378Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1442 294L1489.63 321.5V376.5L1442 404L1394.37 376.5V321.5L1442 294Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1392 378L1439.63 405.5V460.5L1392 488L1344.37 460.5V405.5L1392 378Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1542 294L1589.63 321.5V376.5L1542 404L1494.37 376.5V321.5L1542 294Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1492 378L1539.63 405.5V460.5L1492 488L1444.37 460.5V405.5L1492 378Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1642 294L1689.63 321.5V376.5L1642 404L1594.37 376.5V321.5L1642 294Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1592 378L1639.63 405.5V460.5L1592 488L1544.37 460.5V405.5L1592 378Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1742 294L1789.63 321.5V376.5L1742 404L1694.37 376.5V321.5L1742 294Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1692 378L1739.63 405.5V460.5L1692 488L1644.37 460.5V405.5L1692 378Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1242 462L1289.63 489.5V544.5L1242 572L1194.37 544.5V489.5L1242 462Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1192 546L1239.63 573.5V628.5L1192 656L1144.37 628.5V573.5L1192 546Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1342 462L1389.63 489.5V544.5L1342 572L1294.37 544.5V489.5L1342 462Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1292 546L1339.63 573.5V628.5L1292 656L1244.37 628.5V573.5L1292 546Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1442 462L1489.63 489.5V544.5L1442 572L1394.37 544.5V489.5L1442 462Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1392 546L1439.63 573.5V628.5L1392 656L1344.37 628.5V573.5L1392 546Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1542 462L1589.63 489.5V544.5L1542 572L1494.37 544.5V489.5L1542 462Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1492 546L1539.63 573.5V628.5L1492 656L1444.37 628.5V573.5L1492 546Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1642 462L1689.63 489.5V544.5L1642 572L1594.37 544.5V489.5L1642 462Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1592 546L1639.63 573.5V628.5L1592 656L1544.37 628.5V573.5L1592 546Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1742 462L1789.63 489.5V544.5L1742 572L1694.37 544.5V489.5L1742 462Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1692 546L1739.63 573.5V628.5L1692 656L1644.37 628.5V573.5L1692 546Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1242 630L1289.63 657.5V712.5L1242 740L1194.37 712.5V657.5L1242 630Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1192 714L1239.63 741.5V796.5L1192 824L1144.37 796.5V741.5L1192 714Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1342 630L1389.63 657.5V712.5L1342 740L1294.37 712.5V657.5L1342 630Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1292 714L1339.63 741.5V796.5L1292 824L1244.37 796.5V741.5L1292 714Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1442 630L1489.63 657.5V712.5L1442 740L1394.37 712.5V657.5L1442 630Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1392 714L1439.63 741.5V796.5L1392 824L1344.37 796.5V741.5L1392 714Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1542 630L1589.63 657.5V712.5L1542 740L1494.37 712.5V657.5L1542 630Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1492 714L1539.63 741.5V796.5L1492 824L1444.37 796.5V741.5L1492 714Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1642 630L1689.63 657.5V712.5L1642 740L1594.37 712.5V657.5L1642 630Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1592 714L1639.63 741.5V796.5L1592 824L1544.37 796.5V741.5L1592 714Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1742 630L1789.63 657.5V712.5L1742 740L1694.37 712.5V657.5L1742 630Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1692 714L1739.63 741.5V796.5L1692 824L1644.37 796.5V741.5L1692 714Z",
    fill: "white"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_27_234",
    x: -67.6318,
    y: -54,
    width: 1877.26,
    height: 898,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: 4,
    dy: 4
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 8
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_27_234"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_27_234",
    result: "shape"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_27_234",
    x1: -63,
    y1: 776,
    x2: 1784,
    y2: -0.00000354479,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D9D9D9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D9D9D9",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D9D9D9",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint1_radial_27_234",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(387 365) rotate(90) scale(320)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF8646"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF8646",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint2_radial_27_234",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(907 640) rotate(90) scale(320)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#002D3E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#002D3E",
    stopOpacity: 0
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHeaderSidepages);
export default __webpack_public_path__ + "static/media/header_sidepages.a1790941ad646659d05716ba807f3eef.svg";
export { ForwardRef as ReactComponent };